import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {KreirajQRcodePalete, ParamsModelKreirajQRcodePalete} from '../models/KreirajQrCodePalete'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/palete/kreirajQRcodePalete`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: `Bearer ${auth?.access_token ?? ''}`}

export async function getQrCodePaleteData(params: ParamsModelKreirajQRcodePalete) {
  return await axios.get<Array<KreirajQRcodePalete>>(API, {headers: headers, params: params})
}
